<template>
  <div class="form-text">
    <label
      :for="input.id"
      class="form__label display-block type-weight-700 space-mb-1">
      {{ input.label }}
    </label>

    <textarea
      :id="id"
      ref="input"
      v-model="model"
      :name="input.name"
      :placeholder="input.placeholder"
      class="form-textarea__input"
      :style="{ height }" />
  </div>
</template>

<script>
  import { nanoid } from 'nanoid';
  import autosize from 'autosize';

  export default {
    name: 'FormTextarea',
    props: {
      input: {
        type: Object,
        required: true,
        default: () => {},
      },
      value: {
        type: String,
        required: true,
      },
      height: {
        type: String,
        default: '58px',
      },
    },
    data() {
      return {
        id: nanoid(),
      };
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    mounted() {
      autosize(this.$refs.input);
    },
  };
</script>

<style lang="scss">
  @mixin form-text() {
    display: flex;
    align-items: center;
    width: 100%;
    padding: s(1) s(4);
    font-size: 1em;
    font-weight: 300;
    line-height: 32px;
    color: c('blue');
    background-color: transparent;
    border: 2px solid c('grey');
    border-radius: 5px;

    &::placeholder {
      color: currentColor;
      opacity: 0.5;
    }

    &:hover {
      border-color: rgba(c('blue'), 0.25);
    }

    &:focus {
      border-color: rgba(c('blue'), 0.6);
    }
  }

  /*------------------------------------*
    Form input text
  *------------------------------------*/
  .form-textarea__input {
    @include form-text;
  }
</style>
